import axios from "axios";
import store from "../redux/store.js";

const API_URL = process.env.REACT_APP_API_URL;
const AUDIT_SERVICE_URL = process.env.REACT_APP_AUDIT_SERVICE_URL;
const NOTIFICATION_SERVICE_URL = process.env.REACT_APP_NOTIFICATION_SERVICE_URL;
const DATA_EXPORT_SERVICE_URL = process.env.REACT_APP_DATA_EXPORT_SERVICE_URL;

const API_POST = async (url, data) => {
  let TOKEN = store.getState().authorization.user.token;
  let res = await axios({
    method: "POST",
    headers: {
      "content-type": "application/json",
      authorization: "Bearer " + TOKEN,
    },
    url: API_URL + url,
    data: data,
  }).catch((err) => {
    if (err.response.status === 401) {
      return window.location.replace(
        `${process.env.REACT_APP_CAS_URL}/cas/login?service=${process.env.REACT_APP_SERVICE_NAME}`
      );
    }
    if (err.response.status === 405) {
      throw Object.assign({
        response: {
          data: {
            message: "YEK-G sistem saatleri dışında işlem yapılamamaktadır.",
          },
        },
      });
    }
    if (err.response.status === 403) {
      throw Object.assign({
        response: {
          data: {
            message: "Bu işlemi gerçekleştirmek için yetkiniz yok!",
          },
        },
      });
    }
    throw err;
  });
  return res;
};

const API_DELETE = async (url) => {
  let TOKEN = store.getState().authorization.user.token;
  let res = await axios({
    method: "DELETE",
    headers: {
      "content-type": "application/json",
      authorization: "Bearer " + TOKEN,
    },
    url: API_URL + url,
  }).catch((err) => {
    if (err.response.status === 401) {
      return window.location.replace(
        `${process.env.REACT_APP_CAS_URL}/cas/login?service=${process.env.REACT_APP_SERVICE_NAME}`
      );
    }
    if (err.response.status === 405) {
      throw Object.assign({
        response: {
          data: {
            message: "YEK-G sistem saatleri dışında işlem yapılamamaktadır.",
          },
        },
      });
    }
    if (err.response.status === 403) {
      throw Object.assign({
        response: {
          data: {
            message: "Bu işlemi gerçekleştirmek için yetkiniz yok!",
          },
        },
      });
    }
    throw err;
  });
  return res;
};

const API_GET = async (url, params) => {
  let TOKEN = store.getState().authorization.user.token;
  let res = await axios({
    method: "GET",
    headers: {
      "content-type": "application/json",
      authorization: "Bearer " + TOKEN,
    },
    url: API_URL + url,
    params: params,
    paramsSerializer: (params) => {
      let keys = Object.keys(params);
      let queryString = keys.reduce((acc, key) => {
        // if params is not null or empty string
        if (params[key] !== null && params[key] !== "") {
          if (typeof params[key] === "object") {
            // if object write in same key
            acc += params[key].reduce((objectAcc, value) => {
              objectAcc += key + "=" + value + "&";
              return objectAcc;
            }, "");
          } else {
            acc += key + "=" + params[key] + "&";
          }
        }
        return acc;
      }, "");
      // remove last & and returrn
      return queryString.slice(0, -1);
    },
  }).catch((err) => {
    if (err.response.status === 401) {
      return window.location.replace(
        `${process.env.REACT_APP_CAS_URL}/cas/login?service=${process.env.REACT_APP_SERVICE_NAME}`
      );
    }
    if (err.response.status === 405) {
      throw Object.assign({
        response: {
          data: {
            message: "YEK-G sistem saatleri dışında işlem yapılamamaktadır.",
          },
        },
      });
    }
    if (err.response.status === 403) {
      throw Object.assign({
        response: {
          data: {
            message: "Bu işlemi gerçekleştirmek için yetkiniz yok!",
          },
        },
      });
    }
    throw err;
  });
  return res;
};

const API_PUT = async (url, data, params) => {
  let TOKEN = store.getState().authorization.user.token;
  let res = await axios({
    method: "PUT",
    headers: {
      "content-type": "application/json",
      authorization: "Bearer " + TOKEN,
    },
    url: API_URL + url,
    data: data,
    params: params,
    paramsSerializer: (params) => {
      let keys = Object.keys(params);
      let queryString = keys.reduce((acc, key) => {
        // if params is not null or empty string
        if (params[key] !== null && params[key] !== "") {
          if (typeof params[key] === "object") {
            // if object write in same key
            acc += params[key].reduce((objectAcc, value) => {
              objectAcc += key + "=" + value + "&";
              return objectAcc;
            }, "");
          } else {
            acc += key + "=" + params[key] + "&";
          }
        }
        return acc;
      }, "");
      // remove last & and returrn
      return queryString.slice(0, -1);
    },
  }).catch((err) => {
    if (err.response.status === 401) {
      return window.location.replace(
        `${process.env.REACT_APP_CAS_URL}/cas/login?service=${process.env.REACT_APP_SERVICE_NAME}`
      );
    }
    if (err.response.status === 405) {
      throw Object.assign({
        response: {
          data: {
            message: "YEK-G sistem saatleri dışında işlem yapılamamaktadır.",
          },
        },
      });
    }
    if (err.response.status === 403) {
      throw Object.assign({
        response: {
          data: {
            message: "Bu işlemi gerçekleştirmek için yetkiniz yok!",
          },
        },
      });
    }
    throw err;
  });
  return res;
};

const API_PATCH = async (url) => {
  let TOKEN = store.getState().authorization.user.token;
  let res = await axios({
    method: "PATCH",
    headers: {
      "content-type": "application/json",
      authorization: "Bearer " + TOKEN,
    },
    url: API_URL + url,
  }).catch((err) => {
    if (err.response.status === 401) {
      return window.location.replace(
        `${process.env.REACT_APP_CAS_URL}/cas/login?service=${process.env.REACT_APP_SERVICE_NAME}`
      );
    }
    if (err.response.status === 405) {
      throw Object.assign({
        response: {
          data: {
            message: "YEK-G sistem saatleri dışında işlem yapılamamaktadır.",
          },
        },
      });
    }
    if (err.response.status === 403) {
      throw Object.assign({
        response: {
          data: {
            message: "Bu işlemi gerçekleştirmek için yetkiniz yok!",
          },
        },
      });
    }
    throw err;
  });
  return res;
};

const API_EXPORT = async (url, params) => {
  let TOKEN = store.getState().authorization.user.token;
  return await axios({
    method: "GET",
    headers: {
      "content-type": "application/json",
      authorization: "Bearer " + TOKEN,
    },
    url: DATA_EXPORT_SERVICE_URL + url,
    responseType: "blob",
    params: params,
    paramsSerializer: (params) => {
      let keys = Object.keys(params);
      let queryString = keys.reduce((acc, key) => {
        // if params is not null or empty string
        if (params[key] !== null && params[key] !== "") {
          if (typeof params[key] === "object") {
            // if object write in same key
            acc += params[key].reduce((objectAcc, value) => {
              objectAcc += key + "=" + value + "&";
              return objectAcc;
            }, "");
          } else {
            acc += key + "=" + params[key] + "&";
          }
        }
        return acc;
      }, "");
      // remove last & and returrn
      return queryString.slice(0, -1);
    },
  });
};

const API_AUDIT = async (url, params) => {
  let TOKEN = store.getState().authorization.user.token;
  return await axios({
    method: "GET",
    headers: {
      "content-type": "application/json",
      authorization: "Bearer " + TOKEN,
    },
    url: AUDIT_SERVICE_URL + url,
    params: params,
    paramsSerializer: (params) => {
      let keys = Object.keys(params);
      let queryString = keys.reduce((acc, key) => {
        // if params is not null or empty string  && params[key] !== ''
        if (params[key] !== null) {
          if (typeof params[key] === "object") {
            // if object write in same key
            acc += params[key].reduce((objectAcc, value) => {
              objectAcc += key + "=" + value + "&";
              return objectAcc;
            }, "");
          } else {
            acc += key + "=" + params[key] + "&";
          }
        }
        return acc;
      }, "");
      // remove last & and returrn
      return queryString.slice(0, -1);
    },
  });
};

const API_NOTIFICATION = async (url, method, data, params) => {
  let TOKEN = store.getState().authorization.user.token;
  return await axios({
    method,
    headers: {
      "content-type": "application/json",
      authorization: "Bearer " + TOKEN,
    },
    url: NOTIFICATION_SERVICE_URL + url,
    data,
    params: params,
    paramsSerializer: (params) => {
      let keys = Object.keys(params);
      let queryString = keys.reduce((acc, key) => {
        // if params is not null or empty string
        if (params[key] !== null && params[key] !== "") {
          if (typeof params[key] === "object") {
            // if object write in same key
            if (Array.isArray(params[key])) {
              acc += params[key].reduce((objectAcc, value) => {
                objectAcc += key + "=" + value + "&";
                return objectAcc;
              }, "");
            } else {
              acc += Object.keys(params[key]).reduce((objectAcc, value) => {
                objectAcc += value + "=" + params[key][value] + "&";
                return objectAcc;
              }, "");
            }
          } else {
            acc += key + "=" + params[key] + "&";
          }
        }
        return acc;
      }, "");
      // remove last & and returrn
      return queryString.slice(0, -1);
    },
  });
};

const API_PORTAL = async (url, params) => {
  return await axios({
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
    url: API_URL + url,
    params: params,
  });
};

export {
  API_POST,
  API_GET,
  API_PUT,
  API_DELETE,
  API_PATCH,
  API_EXPORT,
  API_AUDIT,
  API_NOTIFICATION,
  API_PORTAL,
};
